<script lang="ts">
    import { _ } from "svelte-i18n"

    interface Props {
        code: string | null
        messageKey?: string
    }
    let { code, messageKey = "checkout.error-payment" }: Props = $props()
    let copied = $state(false)

    async function copyCode() {
        if (!code) return
        try {
            await navigator.clipboard.writeText(code)
            copied = true
        } catch (e) {
            // Fallback: selektierbar, kein Toast
            const el = document.getElementById("checkout-error-code")
            if (el) {
                const range = document.createRange()
                range.selectNodeContents(el)
                const sel = window.getSelection()
                sel?.removeAllRanges()
                sel?.addRange(range)
            }
        }
    }
</script>

{#if code}
    <div class="checkout-error-box" role="alert" aria-live="assertive">
        <h4>{$_("checkout.error-title")}</h4>
        <p>{$_(messageKey)}</p>
        <p>
            {$_("checkout.error-body")}
            <strong id="checkout-error-code">{code}</strong>
        </p>
        <button type="button" onclick={copyCode}>
            {copied ? $_("checkout.error-copied") : $_("checkout.error-copy")}
        </button>
    </div>
{/if}

<style>
    .checkout-error-box {
        border: 2px solid var(--error-color, #b00020);
        border-radius: 6px;
        padding: 1rem 1.25rem;
        margin: 1rem 0;
        max-width: 100%;
    }
    .checkout-error-box strong {
        font-size: 1.15em;
        letter-spacing: 0.04em;
    }
    .checkout-error-box button {
        margin-top: 0.5rem;
    }
</style>
